import React, { Component } from 'react';
import PropTypes from 'prop-types';

import actions from 'actions';
import { translate } from 'helpers/Translate';
import { redirectToHabitationValuation } from 'helpers/Estima';

/**
 * Animation duration.
 * @type {Number}
 */
export const FAKE_ANIMATION_DURATION = MA.Config.ENVIRONMENT === 'dev' ? 1000 : 7000;

/**
 * FakeAnimation Component.
 */
export default class FakeAnimation extends Component {
    /**
     * React lifecycle.
     * Route user to result page after animation.
     */
    componentDidMount() {
        /**
         * Time for changing step when animation is over.
         * @type {TimeoutToken}
         */
        this.redirectTimeout = setTimeout(() => {
            if (this.props.values._created_habitation_id) {
                redirectToHabitationValuation(this.props.values._created_habitation_id);
            } else {
                this.props.dispatch(actions.nextStep());
            }
        }, FAKE_ANIMATION_DURATION);
    }

    /**
     * React lifecycle.
     * Clear timeout for rerouting.
     */
    componentWillUnmount() {
        clearTimeout(this.redirectTimeout);
    }

    /**
     * React lifecycle.
     */
    render() {
        const { values } = this.props;

        return (
            <ul className="animation animation--fixed" data-step-animation>
                <li className="animation__line">
                    <div className="animation__loader ">
                        <div className="animation__loader-item" />
                    </div>
                    <i className="animation__icon material-icons">check</i>
                    <span className="animation__label">
                        {translate('Récupération des transactions historiques au ')}
                        <strong>{values.address_name}</strong>
                    </span>
                </li>
                <li className="animation__line">
                    <div className="animation__loader ">
                        <div className="animation__loader-item" />
                    </div>
                    <i className="animation__icon material-icons">check</i>
                    <span className="animation__label">
                        {translate('Récupération des ventes comparables à proximité')}
                    </span>
                </li>
                <li className="animation__line">
                    <div className="animation__loader ">
                        <div className="animation__loader-item" />
                    </div>
                    <i className="animation__icon material-icons">check</i>
                    <span className="animation__label">
                        {translate('Calcul de votre estimation')}
                    </span>
                </li>
            </ul>
        );
    }
}

FakeAnimation.propTypes = {
    dispatch: PropTypes.func,
    values: PropTypes.shape({}),
};
